<template>
  <div class="setting_menu" v-if="show">
    <div class="setting_menu__profile" @click="openSettings('profile')">
      <!-- <img v-if="getUserData.image" class="setting_menu__profile__avatar" :src="$w_user_image(getUserData)" alt=""> -->
      <div
        class="setting_menu__profile__avatar"
        :style="'background-color: ' + getUserData.color"
        v-html="$w_user_image(getUserData)"
      ></div>
      <div class="setting_menu__profile__name">
        <p>{{ getUserData.name }}</p>
        <span>{{ getUserData.email }}</span>
      </div>
    </div>
    <div class="setting_menu__link">
      <div @click="openSettings('setting')">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 8.59375C10.3426 8.59375 8.59375 10.3426 8.59375 12.5C8.59375 14.6574 10.3426 16.4062 12.5 16.4062C14.6574 16.4062 16.4062 14.6574 16.4062 12.5C16.4062 10.3426 14.6574 8.59375 12.5 8.59375ZM10.1562 12.5C10.1562 11.2056 11.2056 10.1562 12.5 10.1562C13.7944 10.1562 14.8437 11.2056 14.8437 12.5C14.8437 13.7944 13.7944 14.8437 12.5 14.8437C11.2056 14.8437 10.1562 13.7944 10.1562 12.5Z"
            fill="#464646"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4737 1.30209C12.0107 1.30208 11.6242 1.30208 11.3069 1.32373C10.9766 1.34627 10.6646 1.39485 10.3621 1.52015C9.66022 1.81089 9.10255 2.36854 8.81181 3.07045C8.66046 3.43586 8.61947 3.82097 8.60381 4.23955C8.59123 4.57604 8.42142 4.85679 8.1708 5.00148C7.9202 5.14617 7.59216 5.15285 7.29446 4.99551C6.92413 4.79977 6.57012 4.64271 6.17797 4.59108C5.42474 4.49192 4.66296 4.69604 4.06022 5.15854C3.80047 5.35785 3.60239 5.60376 3.41772 5.87855C3.24031 6.14252 3.04707 6.47725 2.81558 6.87821L2.78928 6.92377C2.55778 7.32472 2.36453 7.65943 2.22463 7.94504C2.07899 8.24238 1.96506 8.53688 1.92232 8.86148C1.82316 9.61472 2.02728 10.3765 2.48977 10.9793C2.73052 11.2929 3.04349 11.5211 3.39812 11.7439C3.6833 11.923 3.84156 12.2105 3.84154 12.5C3.84153 12.7894 3.68327 13.0769 3.39812 13.2561C3.04345 13.4789 2.73045 13.707 2.48968 14.0207C2.02718 14.6234 1.82306 15.3852 1.92222 16.1384C1.96496 16.463 2.07889 16.7576 2.22452 17.0549C2.36443 17.3405 2.55768 17.6752 2.78917 18.0762L2.81548 18.1218C3.04697 18.5227 3.24021 18.8574 3.41762 19.1214C3.60228 19.3962 3.80037 19.6421 4.06012 19.8414C4.66285 20.3039 5.42464 20.508 6.17787 20.4089C6.56999 20.3572 6.92398 20.2002 7.29429 20.0045C7.59203 19.8471 7.92011 19.8538 8.17075 19.9986C8.4214 20.1432 8.59123 20.424 8.60381 20.7605C8.61947 21.1791 8.66047 21.5642 8.81181 21.9296C9.10255 22.6315 9.66022 23.1892 10.3621 23.4799C10.6646 23.6052 10.9766 23.6538 11.3069 23.6763C11.6242 23.6979 12.0107 23.6979 12.4737 23.6979H12.5263C12.9893 23.6979 13.3757 23.6979 13.6931 23.6763C14.0235 23.6538 14.3354 23.6052 14.6379 23.4799C15.3398 23.1892 15.8975 22.6315 16.1882 21.9296C16.3396 21.5642 16.3805 21.1791 16.3962 20.7604C16.4088 20.424 16.5786 20.1432 16.8292 19.9984C17.0798 19.8538 17.4079 19.8471 17.7056 20.0044C18.076 20.2001 18.4299 20.3572 18.8221 20.4088C19.5753 20.5079 20.3371 20.3039 20.9398 19.8414C21.1996 19.642 21.3976 19.3962 21.5823 19.1214C21.7597 18.8574 21.9529 18.5227 22.1844 18.1218L22.2107 18.0762C22.4422 17.6752 22.6355 17.3404 22.7754 17.0548C22.9211 16.7575 23.0349 16.463 23.0777 16.1384C23.1769 15.3851 22.9727 14.6233 22.5102 14.0206C22.2695 13.7069 21.9565 13.4789 21.6019 13.2561C21.3167 13.0769 21.1585 12.7894 21.1585 12.4999C21.1585 12.2105 21.3167 11.9231 21.6018 11.744C21.9566 11.5212 22.2696 11.2931 22.5103 10.9793C22.9728 10.3766 23.177 9.61479 23.0778 8.86155C23.035 8.53695 22.9212 8.24245 22.7755 7.94511C22.6356 7.65952 22.4424 7.32483 22.2109 6.92392L22.1846 6.87832C21.953 6.47735 21.7598 6.14259 21.5824 5.87862C21.3977 5.60383 21.1997 5.35793 20.9399 5.1586C20.3372 4.69611 19.5754 4.49199 18.8221 4.59116C18.43 4.64278 18.0761 4.79982 17.7057 4.99555C17.408 5.15292 17.0799 5.14622 16.8293 5.00151C16.5787 4.85681 16.4088 4.57602 16.3962 4.2395C16.3805 3.82093 16.3396 3.43584 16.1882 3.07045C15.8975 2.36854 15.3398 1.81089 14.6379 1.52015C14.3354 1.39485 14.0235 1.34627 13.6931 1.32373C13.3757 1.30208 12.9893 1.30208 12.5263 1.30209H12.4737ZM10.96 2.96371C11.0404 2.93042 11.1625 2.89972 11.4132 2.8826C11.6711 2.86502 12.004 2.86459 12.5 2.86459C12.9961 2.86459 13.329 2.86502 13.5867 2.8826C13.8375 2.89972 13.9596 2.93042 14.0399 2.96371C14.359 3.09586 14.6125 3.34934 14.7446 3.6684C14.7864 3.76903 14.8209 3.92592 14.8348 4.2979C14.8656 5.12329 15.2917 5.91802 16.048 6.35468C16.8043 6.79134 17.7056 6.76293 18.4359 6.37697C18.7649 6.20303 18.9181 6.15451 19.0261 6.14029C19.3685 6.09522 19.7147 6.188 19.9887 6.39822C20.0577 6.45118 20.1453 6.54156 20.2855 6.75018C20.4297 6.96463 20.5965 7.25272 20.8445 7.6823C21.0925 8.1119 21.2587 8.40041 21.3723 8.63244C21.4828 8.85816 21.5173 8.97925 21.5287 9.0655C21.5738 9.40788 21.481 9.75414 21.2708 10.0281C21.2044 10.1145 21.0859 10.2229 20.7705 10.4209C20.0713 10.8604 19.5961 11.6267 19.596 12.4999C19.596 13.3732 20.0712 14.1396 20.7705 14.5791C21.0857 14.7771 21.2043 14.8854 21.2706 14.9719C21.4809 15.2458 21.5737 15.5921 21.5286 15.9345C21.5172 16.0207 21.4827 16.1418 21.3722 16.3675C21.2586 16.5995 21.0924 16.888 20.8444 17.3176C20.5964 17.7472 20.4296 18.0353 20.2854 18.2498C20.1452 18.4583 20.0576 18.5488 19.9886 18.6017C19.7146 18.812 19.3684 18.9047 19.026 18.8597C18.918 18.8454 18.7648 18.7969 18.4357 18.623C17.7055 18.237 16.8042 18.2087 16.0478 18.6453C15.2917 19.082 14.8656 19.8767 14.8348 20.7021C14.8209 21.0741 14.7864 21.2309 14.7446 21.3317C14.6125 21.6506 14.359 21.9042 14.0399 22.0364C13.9596 22.0696 13.8375 22.1003 13.5867 22.1174C13.329 22.135 12.9961 22.1354 12.5 22.1354C12.004 22.1354 11.6711 22.135 11.4132 22.1174C11.1625 22.1003 11.0404 22.0696 10.96 22.0364C10.6411 21.9042 10.3875 21.6506 10.2554 21.3317C10.2137 21.2309 10.1791 21.0741 10.1652 20.7021C10.1344 19.8768 9.70832 19.082 8.952 18.6453C8.19569 18.2087 7.29442 18.2371 6.56417 18.623C6.23507 18.797 6.08193 18.8455 5.97393 18.8597C5.63154 18.9048 5.28528 18.812 5.01131 18.6018C4.94229 18.5489 4.85466 18.4584 4.71446 18.2498C4.57034 18.0354 4.40352 17.7473 4.1555 17.3177C3.90747 16.8881 3.74139 16.5996 3.62773 16.3676C3.51717 16.1419 3.48271 16.0207 3.47135 15.9345C3.42628 15.5921 3.51906 15.2458 3.72929 14.9719C3.7956 14.8855 3.9142 14.7771 4.2294 14.5791C4.92875 14.1397 5.404 13.3733 5.40404 12.5001C5.40409 11.6267 4.92882 10.8603 4.22941 10.4208C3.91428 10.2228 3.7957 10.1145 3.72939 10.028C3.51917 9.75407 3.42639 9.40781 3.47146 9.06543C3.48281 8.97919 3.51727 8.85808 3.62783 8.63238C3.74149 8.40033 3.90757 8.11182 4.15559 7.68223C4.40363 7.25265 4.57044 6.96455 4.71456 6.7501C4.85476 6.5415 4.9424 6.4511 5.01141 6.39816C5.28539 6.18793 5.63165 6.09515 5.97402 6.14022C6.08203 6.15444 6.23519 6.20296 6.56432 6.37693C7.29453 6.76288 8.19576 6.79128 8.95204 6.35465C9.70833 5.91801 10.1344 5.12331 10.1652 4.29795C10.1791 3.92594 10.2137 3.76904 10.2554 3.6684C10.3875 3.34934 10.6411 3.09586 10.96 2.96371Z"
            fill="#464646"
          />
        </svg>
        {{ $t("app.avatar_menu.settings") }}
      </div>
      <div @click="openSettings('theme')">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2005_3)">
            <mask
              id="mask0_2005_3"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="25"
              height="25"
            >
              <path d="M25 0H0V25H25V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_2005_3)">
              <path
                d="M3.5 7.5C2.34895 7.5 2.08325 8.09896 2.08325 9.25V21.75C2.08325 22.8959 3.02075 23.8334 4.16659 23.8334H16.6666C17.8176 23.8334 18 23.1511 18 22H3.5V7.5ZM20.8333 3H8.33325C7.18221 3 6.24992 3.9323 6.24992 5.08334V17.5834C6.24992 18.7344 7.18221 19.6667 8.33325 19.6667H20.8333C21.9843 19.6667 22.9166 18.7344 22.9166 17.5834V5.08334C22.9166 3.9323 21.9843 3 20.8333 3ZM15.6249 18.4167H7.5V9.41666H15.6249V18.4167ZM21.5 18.4167H17V14V9.41666H21.5V18.4167ZM21.5 8.20834H7.5V4.41666H14.5H21.5V8.20834Z"
                fill="#464646"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2005_3">
              <rect width="25" height="25" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ $t("app.avatar_menu.theme") }}
      </div>
      <div @click="update" v-if="new_vertion">
        {{ $t("app.avatar_menu.update") }} ({{ version }})
      </div>
      <div
        class="logout"
        @mouseover="hoverChangeBackground"
        @mouseout="hoverChangeBackground"
        @click="logout"
      >
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5099 13.6937C15.5099 14.2404 15.9532 14.6837 16.4999 14.6837C17.0467 14.6837 17.4899 14.2404 17.4899 13.6937H15.5099ZM17.4899 5.94001C17.4899 5.39326 17.0467 4.95001 16.4999 4.95001C15.9532 4.95001 15.5099 5.39326 15.5099 5.94001H17.4899ZM12.9502 9.45327C13.4478 9.22669 13.6675 8.63961 13.4409 8.14201C13.2143 7.64441 12.6272 7.42472 12.1296 7.65131L12.9502 9.45327ZM7.25991 16.7112L6.26978 16.7061L6.26997 16.7227L7.25991 16.7112ZM16.4999 25.74L16.5113 24.75C16.5037 24.75 16.4961 24.75 16.4886 24.75L16.4999 25.74ZM25.7399 16.7112L26.73 16.7227L26.7299 16.7061L25.7399 16.7112ZM20.8702 7.65131C20.3725 7.42472 19.7855 7.64441 19.5589 8.14201C19.3324 8.63961 19.552 9.22669 20.0497 9.45327L20.8702 7.65131ZM17.4899 13.6937V5.94001H15.5099V13.6937H17.4899ZM12.1296 7.65131C8.57784 9.26867 6.29022 12.8034 6.26978 16.7061L8.24989 16.7164C8.2663 13.5859 10.1012 10.7506 12.9502 9.45327L12.1296 7.65131ZM6.26997 16.7227C6.33505 22.3141 10.92 26.7942 16.5113 26.73L16.4886 24.75C11.9906 24.8018 8.30219 21.1976 8.24984 16.6997L6.26997 16.7227ZM16.4886 26.73C22.0798 26.7942 26.6651 22.3141 26.73 16.7227L24.75 16.6997C24.6976 21.1976 21.0093 24.8018 16.5113 24.75L16.4886 26.73ZM26.7299 16.7061C26.7094 12.8034 24.422 9.26867 20.8702 7.65131L20.0497 9.45327C22.8986 10.7506 24.7335 13.5859 24.7499 16.7164L26.7299 16.7061Z"
            fill="#F12E2E"
          />
        </svg>
        {{ $t("app.avatar_menu.logout") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventEmitter } from "../../main";
import AutoReload from "../../plugins/AutoReload/AutoReload";
import { getVersion } from "../../plugins/AutoReload/utils";

export default {
  props: {
    show: [Boolean],
  },
  data() {
    return {
      serviceWorkerRegistration: "",
      new_vertion: false,
      version: "",
    };
  },
  computed: {
    ...mapGetters(["getUserData"]),
  },
  mounted() {
    document.addEventListener(
      "swUpdated",
      (event) => {
        {
          this.serviceWorkerRegistration = event.detail;
        }
      },
      { once: true }
    );
    // document.onclick = () => {
    //     console.log('11')
    //     if (this.show) {
    //         EventEmitter.$emit('closeMenuSettings', false)
    //     }
    // }
    EventEmitter.$on("new_vertion", (data) => {
      this.new_vertion = true;
      this.version = data;
    });
  },
  methods: {
    ...mapActions(["fetch_request"]),
    ...mapMutations([
      "setProjects",
      "clearComments",
      "clearTasks",
      "clearUserUsedFileSize",
      "clearUserAllFileSize",
      "clearChat",
      "clearLists",
    ]),
    async logout() {
      const request = await this.fetch_request({
        token: true,
        method: "POST",
        url: this.$w_api.LOGOUT,
        body: {
          token: "",
        },
      });

      const lang = localStorage.getItem("language");
      localStorage.removeItem("w_token");
      localStorage.removeItem("w_clone_token");
      // window.location.reload()
      if (window.isElectron) {
        this.$router.push({
          path: "/login",
          query: {
            app_logout: 1,
          },
        });
      } else {
        this.$router.push("/login");
      }

      setTimeout(() => {
        this.$socket.disconnect();
        this.clearChat();
        this.clearLists();
        this.clearComments();
        this.clearUserUsedFileSize();
        this.clearUserAllFileSize();
        this.clearTasks();
        localStorage.clear();
        localStorage.setItem("language", lang);
      }, 1500);
      console.log("User Logout");
    },
    hoverChangeBackground() {
      if (
        document.querySelector(".setting_menu").classList.contains("color-red")
      ) {
        document.querySelector(".setting_menu").classList.remove("color-red");
      } else {
        document.querySelector(".setting_menu").classList.add("color-red");
      }
    },
    openSettings(e) {
      EventEmitter.$emit("openSettings", e);
    },
    async update() {
      let update_version = new AutoReload({
        config: {
          Enabled: true,
          CheckInterval: 1,
        },
        router: this.$router,
        vm: this,
      });
      update_version.reload();
    },
  },
};
</script>
